import React from 'react';
import { useBrand } from '../../contexts/BrandContext';
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  intro?: string;
  aside?: React.ReactNode;
}
export function PageHeader({
  eyebrow,
  title,
  intro,
  aside
}: PageHeaderProps) {
  const {
    text
  } = useBrand();
  return <header className="bg-cream" data-id="element-201" data-mp="1r5nje3h4roci">
      <div className="mx-auto max-w-shell px-6 pb-10 pt-12 md:px-8 md:pb-12 md:pt-16" data-id="element-202" data-mp="1r6p6557idza2">
        <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-203" data-mp="1w3xdear4ciwj">{eyebrow}</p>
        <div className="mt-4 grid gap-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-end lg:gap-16" data-id="element-204" data-mp="213abjrnfxcef">
          <h1 className="max-w-3xl font-serif text-[2.5rem] font-bold leading-[1.04] tracking-tight text-ink md:text-6xl" data-id="element-205" data-mp="262mysdi84lhj">
            {text(title)}
          </h1>
          {intro && <p className="max-w-xl text-base leading-relaxed text-ink-soft md:text-lg" data-id="element-206" data-mp="bpeyw7fe5jp1">
              {text(intro)}
            </p>}
        </div>
        {aside && <div className="mt-8" data-id="element-207" data-mp="fstdqurlfu0w">{aside}</div>}
      </div>
    </header>;
}